// extracted by mini-css-extract-plugin
module.exports = {"transparentButton":"TransparentButton_transparentButton__1oNWY","small":"TransparentButton_small__N7_QV"};